import React from "react";
import styles from "./Footer.module.css";
import logo from "./../../assets/img/logo.png";
import IconButton from "@mui/joy/IconButton";
import LinkedInLogo from "../../assets/img/Social/linkedin-logo.svg";
import GithubLogo from "../../assets/img/Social/github-mark.svg";
import TwitterLogo from "../../assets/img/Social/twitter-logo.svg";
import InstagramLogo from "../../assets/img/Social/instagram-logo.svg";
import FbLogo from "../../assets/img/Social/fb-logo.svg";
import {
  linkedInURL,
  githubURL,
  instagramURL,
  twitterURL,
  fbURL,
  buyAndSellLink,
} from "../../config";

function Footer() {
  return (
    <footer className={styles.footer}>
      <div className={styles.footerMain}>
        <div className={styles.footerLinks}>
          <a className={styles.linkCategory} href="/Buy">
            Buyer
          </a>
          <div className={styles.footerLinksSection}>
            <a className={styles.linkItem} href="/Buy-or-Rent">
              Random Property
            </a>
          </div>
        </div>

        <span className={styles.pipe}>|</span>

        {/* <div className={styles.footerLinks}>
          <a className={styles.linkCategory} href="/landloard-landing">
            AI News
          </a>
          <div className={styles.footerLinksSection}>
            <a className={styles.linkItem} href="/landlord-onbaord">
              Real Estate News
            </a>
          </div>
        </div> */}

        {/* <span className={styles.pipe}>|</span> */}

        <div className={styles.footerLinks}>
          <a className={styles.linkCategory} href="/Rent-a-Property">
            Rent a Property
          </a>
        </div>

        <span className={styles.pipe}>|</span>

        <div className={styles.footerLinks}>
          <a className={styles.linkCategory} href="/Realtors-and-Brokers">
            Realtors & Brokers
          </a>
          <div className={styles.footerLinksSection}>
            <a className={styles.linkItem} href="/realtor-landing">
              Join As Professional
            </a>
            <div className={styles.footerLinksSection}>
              <a className={styles.linkItem} href="/subscription-plans">
                Professional Plans
              </a>
            </div>
          </div>
        </div>

        <span className={styles.pipe}>|</span>

        <div className={styles.footerLinks}>
          <a className={styles.linkCategory} href="/Agencies">
            Agency
          </a>
          <div className={styles.footerLinksSection}>
            <a className={styles.linkItem} href="/agency-landing">
              Join Agency
            </a>
          </div>
        </div>

        <span className={styles.pipe}>|</span>

        <div className={styles.footerLinks}>
          <a className={styles.linkCategory} href="/Education">
            Education
          </a>
          {/* <div className={styles.footerLinksSection}>
            <a className={styles.linkItem} href="/AI+News">
              AI News
            </a>
            <a className={styles.linkItem} href="/News">
              Real Estate News
            </a>
          </div> */}
        </div>

        <span className={styles.pipe}>|</span>

        <div className={styles.footerLinks}>
          <a className={styles.linkCategory} href="/contact">
            Contact Us
          </a>
        </div>
      </div>

      <div className={styles.footerSocialLinks}>
        <a href={linkedInURL} target="_blank" rel="noopener noreferrer">
          <IconButton size="sm" variant="plain" color="neutral">
            <img
              className={styles.socialIcon}
              src={LinkedInLogo}
              alt="LinkedIn"
            />
          </IconButton>
        </a>
        <a href={githubURL} target="_blank" rel="noopener noreferrer">
          <IconButton size="sm" variant="plain" color="neutral">
            <img className={styles.socialIcon} src={GithubLogo} alt="GitHub" />
          </IconButton>
        </a>
        <a href={twitterURL} target="_blank" rel="noopener noreferrer">
          <IconButton size="sm" variant="plain" color="neutral">
            <img
              className={styles.socialIcon}
              src={TwitterLogo}
              alt="Twitter"
            />
          </IconButton>
        </a>
        <a href={instagramURL} target="_blank" rel="noopener noreferrer">
          <IconButton size="sm" variant="plain" color="neutral">
            <img
              className={styles.socialIcon}
              src={InstagramLogo}
              alt="Instagram"
            />
          </IconButton>
        </a>
        <a href={fbURL} target="_blank" rel="noopener noreferrer">
          <IconButton size="sm" variant="plain" color="neutral">
            <img className={styles.socialIcon} src={FbLogo} alt="Facebook" />
          </IconButton>
        </a>
      </div>

      <div className={styles.footerBottom}>
        <a href="/Terms-and-Conditions" target="_blank">
          Terms and Conditions
        </a>
        <span className={styles.pipe}>|</span>
        <span>&copy; 2022 | FirstLand, Inc | All rights reserved</span>
        <span className={styles.pipe}>|</span>
        <a
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className={styles.backToTop}
        >
          Back To Top
        </a>
      </div>
    </footer>
  );
}

export default Footer;
